import ListBaladiyaRenewal from "./ListBaladiyaRenewal";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBaladiyaRenewData } from "../../../../../store/Api";
import nodeinstance from "../../../../../nodeInstance";

export default function BaladiyaRenewal({ setIndex }) {
  const data = useSelector((state) => state.BaladiyaRenew);
  const dispatch = useDispatch();
  const [searchWords, setSearchWords] = useState([]);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getBaladiyaRenewData(token));
  }, []);

  const updateData = () => {
    dispatch(getBaladiyaRenewData(token));
  };
  console.log(
    ".......Datato be print....",
    searchWords && searchWords[0]?.length
  );

  const [searchResponse, setSearchResponse] = useState([]);

  const getSearchData = async () => {
    try {
      const response = await nodeinstance.get(
        `/baladiya/getEmployeeBySearch/${searchWords && searchWords[0]}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSearchResponse(response.data.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    if (searchWords && searchWords[0]?.length > 3) {
      getSearchData();
    } else {
      console.log("............");
      setSearchResponse([]);
    }
  }, [searchWords]);

  return (
    <>
      <ListBaladiyaRenewal
        titles={[
          "SR NO.",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "ACTUAL PROFESSION",
          "IQAMA PROFESSION",
          "VISA PROVIDER",
          "SPONSOR ID",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "BALADIYA LOCATION",
          "BALADIYA APPLY DATE",
          "BALADIYA ISSUE DATE ",
          "BALADIYA EXPIRY DATE ",
          "BALADIYA VALID DAYS ",
          // "checkBox",
        ]}
        list={searchResponse?.length > 0 ? searchResponse : data?.data?.data}
        loading={loading}
        token={token}
        updateData={updateData}
        uploadFile={""}
        setIndex={setIndex}
        searchWords={searchWords}
        setSearchWords={setSearchWords}
      />
    </>
  );
}
